import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "hint"]

  connect() {
    this.reset()
  }

  select(event) {
    const mealKey = event.currentTarget.dataset.mealKey
    if (!mealKey) return

    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.mealKey === mealKey
      tab.classList.toggle("active", isActive)
      tab.setAttribute("aria-selected", isActive ? "true" : "false")
    })

    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.mealKey === mealKey
      panel.classList.toggle("d-none", !isActive)
      panel.classList.toggle("active", isActive)
      panel.setAttribute("aria-hidden", isActive ? "false" : "true")
    })

    if (this.hasHintTarget) {
      this.hintTarget.classList.add("d-none")
    }
  }

  reset() {
    this.tabTargets.forEach((tab) => {
      tab.classList.remove("active")
      tab.setAttribute("aria-selected", "false")
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.add("d-none")
      panel.classList.remove("active")
      panel.setAttribute("aria-hidden", "true")
    })

    if (this.hasHintTarget) {
      this.hintTarget.classList.remove("d-none")
    }
  }
}
